import axios from "axios";
import {
  encryptData,
  encryptDataByCrypto,
  getLocalUser,
} from "../components/functions/utilities";
import {
  AuthMethods,
  IIntegrationPartner,
  IPWorkspace,
  UserRole,
} from "../interfaces/interfaces";

export const IP_DEV_REST_LOCATION = `${
  import.meta.env.VITE_IP_DEV_REST_LOCATION
}`;

class IpRestService {
  // shopifyAuth = (): Promise<any> => {
  //     return new Promise((resolve, reject) => {
  //       axios.get(`${IP_DEV_REST_LOCATION}/api/shopify/auth`)
  //       .then(res => {
  //         resolve(res.data)
  //       })
  //       .catch(err => {
  //         reject(err)
  //       })
  //     })
  //   }

  getTestCharts = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${IP_DEV_REST_LOCATION}/api/proposalCharts/getByIP?ipWorkspace=634b86d8d694d9895d5ea17f`
        )
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getAllActiveWorkspaces = (): Promise<IPWorkspace[]> => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${IP_DEV_REST_LOCATION}/api/ipWorkspace/getAllActive`)
        .then((res) => {
          try {
            const user = getLocalUser();
            const otherUserIds = import.meta.env.VITE_EXCLUDE_COMPANY_IDS.split(
              ","
            );
            console.log(
              "otherUserIds",
              otherUserIds,
              user.companyId,
              otherUserIds.includes(String(user.companyId))
            );
            if (!otherUserIds.includes(String(user.companyId))) {
              resolve(
                res.data.filter(
                  (ws) => ws.workspaceName != "Merito Product Tracking"
                )
              );
            } else {
              resolve(res.data);
            }
          } catch (err) {
            resolve(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  lambdaCharts = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      const body = {
        user: "634909d4c6122e1ca88b681e",
        method: "workspace",
        workspaceId: "634e4f7e85160b139d3f4ad1",
        dataSet: "asd",
        accessToken: "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",
      };
      axios
        .post(
          `https://9tr2rs0ttj.execute-api.ap-south-1.amazonaws.com/eda/`,
          body
        )
        .then((res: any) => {
          //
          resolve(res.data.body);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getWorkspaceById = (workspaceId: string): Promise<IPWorkspace> => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${IP_DEV_REST_LOCATION}/api/ipWorkspace/getById?id=${workspaceId}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getAllActiveWorkspaceByIP = (IpId: string): Promise<IPWorkspace[]> => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${IP_DEV_REST_LOCATION}/api/ipWorkspace/getAllActiveByIP?ipId=${IpId}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getAllActiveWorkspaceByIPName = (ipName: string): Promise<IPWorkspace[]> => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${IP_DEV_REST_LOCATION}/api/ipWorkspace/getAllActiveByIPName?ipName=${ipName}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getIpByName = (ipName: string): Promise<IIntegrationPartner> => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${IP_DEV_REST_LOCATION}/api/integrationPartner/getIpByName?ipName=${ipName}`
        )
        .then((res) => {
          resolve(res.data as IIntegrationPartner);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getAllIp = (): Promise<IIntegrationPartner[]> => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${IP_DEV_REST_LOCATION}/api/integrationPartner/get`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  addCustomerSubscription = (
    workspace: IPWorkspace,
    reportId: number
  ): Promise<void> => {
    return new Promise((resolve, reject) => {
      const user = getLocalUser();
      const body = {
        jigsawUserId: user.id,
        dataSet: "634e4f5e85160b139d3f4aca",
        ipWorkspace: workspace._id,
        integrationPartner: workspace.integrationPartner._id,
        jigsawReportId: reportId,
        edaStatus: "active",
        refreshInterval: workspace.refreshInterval,
      };
      axios
        .post(`${IP_DEV_REST_LOCATION}/api/customerSubscription/add`, body)
        .then((res) => {
          //
        })
        .catch((err) => {
          //
        });
    });
  };

  getByRC = (referralCode: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${IP_DEV_REST_LOCATION}/api/integrationPartner/getByRC?referralCode=${referralCode}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getWorkspaceByName = (
    wsName: string,
    ipName: string
  ): Promise<IPWorkspace> => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${IP_DEV_REST_LOCATION}/api/ipWorkspace/getByName?ipName=${ipName}&wsName=${wsName}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  uninstallUser = (
    ipId: string,
    ipName: string,
    accessTokenId,
    disconnectedFromFE: boolean = true
  ): Promise<any> => {
    return new Promise((resolve, reject) => {
      const user = getLocalUser();
      const body = {
        ipId: ipId,
        userId: user.id,
        companyId: user.companyId,
        ipName,
        accessTokenId,
        disconnectedFromFE,
      };
      axios
        .post(`${IP_DEV_REST_LOCATION}/integrations/shopify/disconnect`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getProposalCharts = (ipWorkspace: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${IP_DEV_REST_LOCATION}/api/proposalCharts/getByIP?ipWorkspace=${ipWorkspace}`
        )
        .then((res) => {
          resolve(res.data?.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  addIntegrationCustomerDetails = ({
    ipId,
    accDetails,
    agencyClientId,
  }: {
    ipId: string;
    accDetails: any[];
    agencyClientId: number | null;
  }): Promise<any> => {
    const user = getLocalUser();
    const body = {
      ipId: ipId,
      userId: user.id,
      companyId: user.companyId,
      accDetails,
      extraDetails: {
        userId: user.id,
        companyId: user.companyId,
        role: user.role,
        email: user.email,
        agencyClientId,
      },
    };
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${IP_DEV_REST_LOCATION}/integrations/google/addCustomerDetails`,
          body
        )
        .then((res: any) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  addGAIntegrationCustomerDetails = ({
    ipId,
    accDetails,
    agencyClientId,
  }: {
    ipId: string;
    accDetails: any[];
    agencyClientId: number | null;
  }): Promise<any> => {
    console.log(ipId);
    const user = getLocalUser();
    const body = {
      ipId: ipId,
      userId: user.id,
      companyId: user.companyId,
      accDetails,
      extraDetails: {
        userId: user.id,
        companyId: user.companyId,
        role: user.role,
        email: user.email,
        agencyClientId,
      },
    };
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${IP_DEV_REST_LOCATION}/integrations/googleAnalytics/addCustomerDetails`,
          body
        )
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  addFacebookAdAccount = ({
    ipId,
    accDetails,
    agencyClientId,
  }: {
    ipId: string;
    accDetails: any[];
    agencyClientId: number | null;
  }): Promise<any> => {
    const user = getLocalUser();

    return new Promise((resolve, reject) => {
      const accDetailsChanged = accDetails.map((detail) => {
        return {
          parentName: detail.name,
          parentId: detail.id,
        };
      });
      const body = {
        ipId: ipId,
        userId: user.id,
        companyId: user.companyId,
        accDetails: accDetailsChanged,
        extraDetails: {
          userId: user.id,
          companyId: user.companyId,
          role: user.role,
          email: user.email,
          agencyClientId,
        },
      };
      axios
        .post(`${IP_DEV_REST_LOCATION}/integrations/metaAds/addAdAccount`, body)
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  addAmazonAdAccount = ({
    ipId,
    accDetails,
    agencyClientId,
  }: {
    ipId: string;
    accDetails: any[];
    agencyClientId: number | null;
  }): Promise<any> => {
    const user = getLocalUser();

    return new Promise((resolve, reject) => {
      const accDetailsChanged = accDetails.map((detail) => {
        return {
          parentName: detail.name,
          parentId: detail.id,
          id: detail?.profileId,
        };
      });
      const body = {
        ipId: ipId,
        userId: user.id,
        companyId: user.companyId,
        accDetails: accDetailsChanged,
        extraDetails: {
          userId: user.id,
          companyId: user.companyId,
          role: user.role,
          email: user.email,
          agencyClientId,
        },
      };
      axios
        .post(
          `${IP_DEV_REST_LOCATION}/integrations/amazonAds/addAdAccount`,
          body
        )
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  shopifyConnect = ({
    host,
    ipId,
    isUpdated = false,
    agencyClientId = null,
  }: {
    host: string;
    ipId: string;
    isUpdated?: boolean;
    agencyClientId?: number;
  }): Promise<any> => {
    return new Promise((resolve, reject) => {
      const user = getLocalUser();
      const body = {
        ipId,
        host,
        userId: user.id,
        companyId: user.companyId,
        isUpdated,
        extraDetails: {
          userId: user.id,
          companyId: user.companyId,
          role: user.role,
          email: user.email,
          agencyClientId,
        },
      };
      axios
        .post(`${IP_DEV_REST_LOCATION}/integrations/shopify/connect`, body)
        .then((res: any) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getCustomerAccounts = (accountId) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${IP_DEV_REST_LOCATION}/api/customeraccounts/accounts?accountId=${accountId}`
        )
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getFilteredIpByNames = (ipNames: string[]): Promise<{ data: any[] }> => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${IP_DEV_REST_LOCATION}/api/integrationpartner/filteredip`, {
          params: {
            ipName: ipNames.toString(),
          },
        })
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getAllIpByStatus = (status: string = "active"): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${IP_DEV_REST_LOCATION}/api/integrationPartner/getAllIpByStatus?status=${status}`
        )
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err) => reject);
    });
  };

  connectViaPasswordForm = ({
    email,
    password,
    integrationPartner,
    extraDetails = {},
    agencyClientId,
  }: {
    email: string;
    password: string;
    integrationPartner: IIntegrationPartner;
    extraDetails?: Record<string, any>;
    agencyClientId: number | null;
  }): Promise<void> => {
    const user = getLocalUser();
    const otpMethods = new Set([AuthMethods.email_otp]);
    // console.log("integrationPartner", integrationPartner);
    const body = {
      userId: user.id,
      companyId:
        user?.role == UserRole.Agency ? agencyClientId : user.companyId,
      email,
      password: otpMethods.has(integrationPartner?.authMethod as AuthMethods)
        ? encryptDataByCrypto(email)
        : encryptDataByCrypto(password),
      integrationPartner,
      agencyClientId: agencyClientId,
      ...extraDetails,
    };

    const formattedCompanyName = integrationPartner?.companyName
      .replace(/\s+/g, "")
      .toLowerCase();

    return new Promise((resolve, reject) => {
      axios
        .post(
          `${IP_DEV_REST_LOCATION}/integrations/${formattedCompanyName}/connect`,
          body
        )
        .then((res) => resolve)
        .catch((err) => reject);
    });
  };

  addRpaBrands = ({
    integrationPartner,
    accDetails,
    agencyClientId,
  }: {
    integrationPartner: IIntegrationPartner;
    accDetails: any[];
    agencyClientId: number | null;
  }): Promise<any> => {
    const user = getLocalUser();

    return new Promise((resolve, reject) => {
      const body = {
        ipId: integrationPartner?._id,
        userId: user.id,
        companyId: user.companyId,
        accDetails,
        extraDetails: {
          userId: user.id,
          companyId: user.companyId,
          role: user.role,
          email: user.email,
          agencyClientId:
            user?.role === UserRole.Agency ? agencyClientId : null,
        },
      };

      const formattedIpName = integrationPartner?.companyName.replace(
        /\s+/g,
        ""
      );

      axios
        .post(
          `${IP_DEV_REST_LOCATION}/integrations/${formattedIpName}/addBrands`,
          body
        )
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
}

export const IpRestS = new IpRestService();
